<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

            <!-- <div class="btn_menu_contextual" @click="set_modulo('busqueda')">
                Búsqueda
            </div> -->


        </div>

        <div class="contenido_">
            <Listado />
        </div>
        <!-- <Busqueda v-if="modulo == 'busqueda'" /> -->

    </div>
</template>

<script>
    import Listado from './Listado.vue'
    export default {
        name: 'Descuentos',
        components: {
            Listado
        },
        data() {
            return {

            }
        },
        methods: {

        },
    }
</script>

<style></style>